import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import * as React from 'react';
import { Route, Routes } from 'react-router';
import { Basket } from "./components/Basket";
import { Contract } from "./components/Contract";
import { ContractVariation } from "./components/ContractVariation";
import { Dashboard } from './components/Dashboard';
import { DispatchRequest } from "./components/DispatchRequest";
import { Audits } from "./components/Entities/Audits";
import { Contracts } from "./components/Entities/Contracts";
import { Dispatches } from "./components/Entities/Dispatches";
import { StorageRequests } from './components/Entities/StorageRequests';
import { Layout } from './components/Layout/';
import { MaterialAudit } from "./components/MaterialAudit";
import { Reports } from "./components/Report";
import { StorageReportForm, DispatchReportForm } from "./components/Report/ReportForm";
import { Settings } from "./components/Settings";
import { SignIn } from './components/SignIn';
import { StorageRequest } from './components/StorageRequest';
import Theme from './components/Theme';
import { BasketContextProvider } from "./contexts/BasketContext";
import { Feature, PermissionContext, PermissionContextProvider } from "./contexts/PermissionContext";
import { ReturnContextProvider } from "./contexts/ReturnContext";
import { SearchContextProvider } from './contexts/SearchContext';
import './custom.scss';


export default class App extends React.Component<any, any> {
    static displayName = App.name;

    constructor(props: any) {
        super(props);

        this.state = {


        }
    }
    render() {

        return (
            <ThemeProvider theme={Theme}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                    <AuthenticatedTemplate>
                        <PermissionContextProvider>
                            <SearchContextProvider>
                                <BasketContextProvider>
                                    <ReturnContextProvider>
                                        <Layout >
                                            <AuthorizedRouteList />
                                        </Layout>
                                    </ReturnContextProvider>
                                </BasketContextProvider>
                            </SearchContextProvider >
                        </PermissionContextProvider>
                    </AuthenticatedTemplate>
                    <UnauthenticatedTemplate>
                        <SignIn />
                    </UnauthenticatedTemplate>
                </LocalizationProvider>
            </ThemeProvider>
        );
    }
}



const AuthorizedRouteList: React.FC = () => {


    const permissionContext = React.useContext(PermissionContext);

    return (

        <Routes>
            <Route path='/' element={<Dashboard />} />
            <Route path='/basket' element={<Basket />} />
            <Route path='/return' element={<Basket returnBasket />} />
            {permissionContext.isPermitted(Feature.Contract) &&
                <>
                    <Route path='/contract' element={<Contracts />} />
                    <Route path='/contract/*' element={<Contract />} />
                    <Route path='/contract/update/:cId' element={<Contract />} />
                </>
            }
            {permissionContext.isPermitted(Feature.ContractVariation) &&
                <>
                    <Route path='/contractvariation/:cId' element={<ContractVariation />} />
                    <Route path='/contractvariation/update/:cId/:cvId' element={<ContractVariation />} />
                </>
            }
            {permissionContext.isPermitted(Feature.StorageRequest) &&
                <>
                    <Route path='/storagerequest' element={<StorageRequests />} />
                    <Route path='/storagerequest/*' element={<StorageRequest />} />
                    <Route path='/storagerequest/update/:srId' element={<StorageRequest />} />
                </>
            }

            {permissionContext.isPermitted(Feature.DispatchRequest) &&
                <>
                    <Route path='/dispatchrequest' element={<Dispatches />} />
                    <Route path='/dispatchrequest/*' element={<DispatchRequest />} />
                    <Route path='/dispatchrequest/update/:drId' element={<DispatchRequest />} />
                </>
            }

            {permissionContext.isPermitted(Feature.Audit) &&
                <>
                    <Route path='/audit' element={<Audits />} />
                    <Route path='/audit/*' element={<MaterialAudit />} />
                    <Route path='/audit/update/:maId' element={<MaterialAudit />} />
                </>
            }

            {permissionContext.isPermitted(Feature.Reports) &&
                <>
                    <Route path='/report' element={<Reports />} />
                    <Route path='/report/storage' element={<StorageReportForm />} />
                    <Route path='/report/dispatch' element={<DispatchReportForm />} />
                </>
            }


            <Route path='/settings' element={<Settings />} />
        </Routes>

    );


}